import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ErrorService } from '../../../shared/services/error.service';
import { PasswordResetInit } from './password-reset-init.service';

@Component({
    selector: 'jhi-password-reset-init',
    templateUrl: './password-reset-init.component.html'
})
export class PasswordResetInitComponent implements OnInit, AfterViewInit {
    resetAccount: any;
    success = false;

    @ViewChild('resetRequestForm') resetRequestForm: NgForm;

    @ViewChild('emailInput', { read : ElementRef }) emailInputElement: ElementRef;

    constructor(
        private passwordResetInit: PasswordResetInit,
        private errorService: ErrorService
    ) {
    }

    ngOnInit() {
        this.resetAccount = {};
    }

    ngAfterViewInit() {
        if (this.emailInputElement != null) {
            this.emailInputElement.nativeElement.focus();
        }
    }

    requestReset () {
        if (!this.resetRequestForm.valid) {
            this.errorService.markAllControlsAsTouched(this.resetRequestForm);
        } else {
            this.passwordResetInit.save(this.resetAccount.email).subscribe(() => {
                this.success = true;
            }, (_response) => {
                this.success = false;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/password-reset/init/password-reset-init.component.ts